import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BASE_URL } from 'baseConfig';
const token = localStorage.getItem('token')


export const categoryServiceApi = createApi({
    reducerPath: 'categoryServiceApi',
    baseQuery: fetchBaseQuery({ baseUrl: `${BASE_URL}` }),
    tagTypes: ['Category'],
    endpoints: (builder) => ({

        getAllCategory: builder.query({
            query: () => `/v1/category`,
            providesTags: ['Category'],
        }),
        getCountCategory: builder.query({
            query: () => `/v1/category/count`,
            providesTags: ['Category'],
        }),

        getByCategoryId: builder.query({
            query: (id) => `/v1/category/getById/${id}`,
            providesTags: ['Category'],
        }),

        getSearchCategory: builder.query({
            query: (searchQuery) => `/v1/category/search?searchQuery=${searchQuery}`,
            providesTags: ['Category'],
        }),


        createCategory: builder.mutation({
            query: (formData) => ({
                url: `/v1/category/add`,
                method: 'POST',
                body: formData,
                headers: {
                    'authorization': token,
                },
            }),
            invalidatesTags: ['Category'],
        }),

        updateCategory: builder.mutation({
             query: (data) =>({
                url: `/v1/category/update/${data.id}`,
                method: 'PUT',
                headers: {
                    'authorization': token,
                },
                body: data.values,
            }),
            invalidatesTags: ['Category'],
        }),

        deleteCategory: builder.mutation({
            query: (id) => ({
                url: `/v1/category/delete/${id}`,
                method: 'DELETE',
                headers: {
                    'authorization': token,
                    'Content-Type': 'application/json',
                },
            }),
            invalidatesTags: ['Category'],
        }),

        reorderCategories: builder.mutation({
            query: (values) => ({
                url: `/v1/category/reorder`,
                method: 'PUT',
                headers: {
                    'authorization': token,
                    'Content-Type': 'application/json',
                },
                body: values,
            }),
            invalidatesTags: ['Category'],
        }),
    }),
});

export const { useGetAllCategoryQuery, useCreateCategoryMutation, useDeleteCategoryMutation, useUpdateCategoryMutation, useGetByCategoryIdQuery, useGetCountCategoryQuery, useGetSearchCategoryQuery, useReorderCategoriesMutation } = categoryServiceApi;